import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./refresh.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./refresh.component.scss?ngResource";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { ApplicationsRoutingConstants } from "../../applications-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../../application/view-application/view-application-routing.constants";
let RefreshComponent = class RefreshComponent {
    router;
    route;
    appControllerService;
    moduleId;
    jobId;
    type;
    settingsRoute;
    constructor(router, route, appControllerService) {
        this.router = router;
        this.route = route;
        this.appControllerService = appControllerService;
        this.moduleId = this.route.snapshot.paramMap.get("moduleId");
        this.jobId = this.route.snapshot.paramMap.get("jobId");
        this.type = this.route.snapshot.paramMap.get("type");
        this.settingsRoute = this.route.snapshot.paramMap.get("settingsRoute");
    }
    ngAfterContentInit() {
        if (this.settingsRoute !== undefined && this.settingsRoute !== null && this.settingsRoute !== "") {
            this.router.navigate([
                this.settingsRoute
            ]);
        }
        else if (this.type === ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE) {
            if (this.moduleId && this.jobId) {
                this.appControllerService.setSelectedModule(+this.moduleId);
                this.appControllerService.selectedJobID = +this.jobId;
                this.router.navigate([AppRoutingConstants.createRouteToView(this.moduleId + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, this.jobId + "")]).then(() => {
                    // window.location.reload();
                });
            }
            else {
                this.goToDefaultNavigatorPath();
            }
        }
        else {
            this.goToDefaultNavigatorPath();
        }
    }
    ngAfterViewInit() {
    }
    ngOnInit() {
    }
    goToDefaultNavigatorPath() {
        this.router.navigate([
            AppRoutingConstants.ROUTE_SEPERATOR +
                this.appControllerService.selectedModuleID +
                AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE,
        ]);
    }
    static ctorParameters = () => [
        { type: Router },
        { type: ActivatedRoute },
        { type: AppControllerService }
    ];
};
RefreshComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-refresh",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RefreshComponent);
export { RefreshComponent };
